import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";
import { useTranslation } from "react-i18next";

export interface YearOfDevelopemntFilterProps {
  value: Array<AutocompleteData> | undefined;
  onChange?: Dispatch<Array<AutocompleteData>>;
}

export const YearDevelopemntFilter = ({
  value = [],
  onChange,
}: YearOfDevelopemntFilterProps) => {
  const { t } = useTranslation();
  return (
    <ColorSearchAutocomplete
      label={t("filter_color_code_year_development")}
      type="yearOfDevelopment"
      value={value}
      onChange={onChange}
    />
  );
};
